import { databases } from "@/lib/appwrite";
import { ID } from "appwrite";

const dbId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const sessionColl = import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID;
const breakColl = import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID;

// Actualizar sesión principal (clockIn/clockOut)
export const updateWorkSession = async (
  sessionId: string,
  updates: {
    clockIn?: string;
    clockOut?: string;
    clockInLocation?: string;
    clockOutLocation?: string;
  }
) => {
  return databases.updateDocument(dbId, sessionColl, sessionId, updates);
};

// Actualizar un break específico - CAMBIO AQUÍ
export const updateWorkBreak = async (
  breakId: string,
  updates: {
    startTime?: string;
    endTime?: string | null; // Permitir null
    location?: string;
  }
) => {
  // Convertir null a undefined para Appwrite
  const cleanUpdates = {
    ...updates,
    endTime: updates.endTime === null ? undefined : updates.endTime
  };
  
  return databases.updateDocument(dbId, breakColl, breakId, cleanUpdates);
};

// Crear un nuevo break
export const createWorkBreak = async (
  sessionId: string,
  userId: string,
  startTime: string
) => {
  return databases.createDocument(dbId, breakColl, ID.unique(), {
    workSessionId: sessionId,
    userId,
    startTime,
    isActive: true
  });
};

// Crear un break ya finalizado (uso admin)
export const createCompletedBreak = async (
  sessionId: string,
  userId: string,
  startTime: string,
  endTime: string,
  breakDuration: number
) => {
  return databases.createDocument(dbId, breakColl, ID.unique(), {
    workSessionId: sessionId,
    userId,
    startTime,
    endTime,
    breakDuration,
    isActive: false,
  });
};